import React from "react";
import Routes from "./Routes";
import { pages } from "./pages.lazy";

function App() {
  return (
    <Routes pages={pages} />
  );
}

export default App;
